<template>
    <b-container>
        <div class="row">
            <div class="col-11 mx-auto">
                <SgaStepHeader
                    :title="$t('front.sga.checkout.datos_titulo')"
                    :description="$t('front.sga.checkout.datos_descripcion')"
                />
                <ValidationObserver tag="form" ref="observer2" @submit.prevent="submit()">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.nombre"
                                id="nombre"
                                rules="required"
                                :disabled="loading"
                                :label="$t('formularios.nombre')"
                                :name="$t('formularios.nombre')"
                            />
                        </div>
                        <div class="col-12 col-lg-6" v-if="localDatosCompradores.tipo_dni !== 'NIF'">
                            <FormInput
                                v-model="localDatosCompradores.apellidos"
                                id="apellidos"
                                rules="required"
                                :disabled="loading"
                                :label="$t('formularios.apellidos')"
                                :name="$t('formularios.apellidos')"
                            />
                        </div>
                        <div class="col-12 col-lg-6" v-if="localDatosCompradores.tipo_dni !== 'NIF'">
                            <FormInput
                                v-model="localDatosCompradores.edad"
                                id="edad"
                                rules="required"
                                :disabled="loading"
                                :label="$t('formularios.edad')"
                                :name="$t('formularios.edad')"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('formularios.telefono') }}</label>
                                <PhoneInput
                                    :phone="localDatosCompradores.telefono"
                                    :desactivar="loading"
                                    :required="false"
                                    @setNumber="setPhoneNumber"
                                    @validNumber="(valid) => isValidNumber = valid"
                                />
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.cp"
                                id="cp"
                                rules="required"
                                :disabled="loading"
                                :label="$t('formularios.cp')"
                                :name="$t('formularios.cp')"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <div :class="{ 'field-locked': isSgaProfileLocked }">
                                <DocumentoTipo
                                    :value="localDatosCompradores.tipo_dni"
                                    :disabled="loading || isSgaProfileLocked"
                                    @input="val => { localDatosCompradores.tipo_dni = val; }"
                                />
                                <span v-if="isSgaProfileLocked" class="lock-badge">
                                    🔒 {{ $t('front.sga.checkout.datos_verificados') }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div :class="{ 'field-locked': isSgaProfileLocked }">
                                <DocumentoValor
                                    :type="localDatosCompradores.tipo_dni"
                                    :value="localDatosCompradores.dni"
                                    :disabled="loading || isSgaProfileLocked"
                                    @input="val => { localDatosCompradores.dni = val; }"
                                />
                                <span v-if="isSgaProfileLocked" class="lock-badge">
                                    🔒 {{ $t('front.sga.checkout.datos_verificados') }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div :class="{ 'field-locked': isSgaProfileLocked }">
                                <FormInput
                                    v-model="localDatosCompradores.email"
                                    id="email"
                                    vid="confirmation"
                                    rules="required|email"
                                    :disabled="loading || isSgaProfileLocked"
                                    :readonly="isSgaProfileLocked"
                                    :label="$t('formularios.email')"
                                    :name="$t('formularios.email')"
                                />
                                <span v-if="isSgaProfileLocked" class="lock-badge">
                                    🔒 {{ $t('front.sga.checkout.datos_verificados') }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div :class="{ 'field-locked': isSgaProfileLocked }">
                                <FormInput
                                    v-model="localDatosCompradores.email_confirmation"
                                    id="email_confirmation"
                                    :rules="'required|confirmed_ci:@confirmation'"
                                    :disabled="loading || isSgaProfileLocked"
                                    :readonly="isSgaProfileLocked"
                                    :label="$t('formularios.confirmar_email')"
                                    :name="$t('formularios.confirmar_email')"
                                />
                                <span v-if="isSgaProfileLocked" class="lock-badge">
                                    🔒 {{ $t('front.sga.checkout.datos_verificados') }}
                                </span>
                            </div>
                        </div>

                        <template v-if="errors">
                            <div class="col-11 alert alert-danger m-auto" style="margin-top: 1.5rem !important; margin-bottom: 15px !important;" v-for="(fieldErrors, field) in errors" :key="field" id="errors">
                                <ul class="p-1 m-0" v-for="(message, i) in fieldErrors" :key="i">
                                    <li>{{ message }}</li>
                                </ul>
                            </div>
                        </template>
                    </div>

                    <div>
                        <p class="h3 text-bold my-3">
                            {{ $t('eventos.entradas_nominativas_titulo') }}
                        </p>
                        <br/>
                        <p class="text-bold">
                            {{ $t('eventos.entradas_nominativas_datos') }}
                        </p>
                        <br/>
                        <p class="text-bold">
                            {{ $t('eventos.entradas_nominativas_documento') }}
                        </p>
                    </div>

                    <div class="h5 mt-lg-5">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="rellenar_datos_entradas" v-model="rellenar_datos_entradas" />
                            <label for="rellenar_datos_entradas" class="custom-control-label pt-1">
                                {{ $t('eventos_sga.rellenar_datos') }}
                            </label>
                        </div>
                    </div>

                    <template v-if="Array.isArray(items_carrito) && items_carrito.length > 0">
                        <div v-for="(entrada, index) in array_entradas" :key="'entrada-' + index">
                            <EntradaFormComponent
                                :entrada.sync="array_entradas[index]"
                                :index="index"
                                :desactivar="loading"
                            />
                        </div>
                    </template>
                    <div class="d-flex flex-md-row justify-content-center justify-content-md-start mt-4 mb-5">
                        <button
                            id="compra-responsive"
                            :class="['button', 'large-button', { 'effect-button': !loading }]"
                            type="submit"
                            :disabled="loading"
                        >
                            <span>{{ $t('partido.continuar') }}</span>
                        </button>

                        <span
                            id="atras"
                            :class="['button', 'large-button', 'ml-lg-3', 'compra-responsive', { 'effect-button': !loading }]"
                            @click="cambiarAsiento()"
                        >
                            <span>{{ $t('formularios.atras') }}</span>
                        </span>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </b-container>
</template>

<script setup>
    import { ref, watch, computed, onMounted, getCurrentInstance, nextTick } from 'vue';
    import FormInput from '@/components/common/FormInput.vue';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo';
    import DocumentoValor from '@/components/common/DocumentoValor';
    import EntradaFormComponent from './EntradaFormComponent';
    import SgaStepHeader from './SgaStepHeader.vue';
    import { useDatosCompradoresSga } from '@/composables/front/checkout/useDatosCompradoresSga';

    const props = defineProps({
        items_carrito: {
            type: Array,
            required: true,
            default: () => []
        },
        sga_event_id: {
            type: String,
            required: true
        },
        datos_comprador: {
            type: Object,
            required: true
        },
        selectedProfile: {
            type: Object,
            default: null
        }
    });

    const emit = defineEmits(['fillDatosCompradores', 'setDatosCobro', 'volver']);
    const { proxy } = getCurrentInstance();
    const observer2 = ref(null);
    const isValidNumber = ref(false);
    
    // ── Computed: Bloqueo de campos por perfil SGA ──
    const isSgaProfileLocked = computed(() => !!props.selectedProfile);
    
    const {
        localDatosCompradores,
        loading,
        errors,
        array_entradas,
        rellenar_datos_entradas,
        guardarDatos,
        cambiarAsiento,
        setPhoneNumber,
        sincronizarPrimeraEntrada,
    } = useDatosCompradoresSga(props, emit, proxy);

    onMounted(() => {
        observer2.value.reset();
    });

    async function submit() {
        const isValid = await observer2.value.validate();
        if (isValid && isValidNumber.value) {
            guardarDatos();
        } else {
            nextTick(() => {
                proxy.$scrollTo('.is-invalid', 100);
            });
        }
    }

    watch(rellenar_datos_entradas, val => {
        sincronizarPrimeraEntrada(val);
    });

    watch(() => localDatosCompradores.value.nombre, val => {
        if (array_entradas.value[0]) {
            array_entradas.value.splice(0, 1, {
                ...array_entradas.value[0],
                nombre: rellenar_datos_entradas.value ? val : null,
            });
        }
    });

    watch(() => localDatosCompradores.value.apellidos, val => {
        if (array_entradas.value[0]) {
            array_entradas.value.splice(0, 1, {
                ...array_entradas.value[0],
                apellidos: rellenar_datos_entradas.value ? val : null,
            });
        }
    });

    watch(() => localDatosCompradores.value.email, val => {
        if (array_entradas.value[0]) {
            array_entradas.value.splice(0, 1, {
                ...array_entradas.value[0],
                email: rellenar_datos_entradas.value ? val : null,
            });
        }
    });

    watch(() => localDatosCompradores.value.dni, val => {
        if (array_entradas.value[0]) {
            array_entradas.value.splice(0, 1, {
                ...array_entradas.value[0],
                dni: rellenar_datos_entradas.value ? val : null,
            });
        }
    });

    watch(() => localDatosCompradores.value.tipo_dni, val => {
        if (array_entradas.value[0]) {
            array_entradas.value.splice(0, 1, {
                ...array_entradas.value[0],
                documento_tipo: rellenar_datos_entradas.value ? val : null,
            });
        }
    });
</script>

<style scoped>
    @media (max-width: 700px) {
        .button.large-button {
            min-width: 40vw !important;
            margin-right: 4%;
        }

        #compra-responsive {
            min-width: 45vw;
            margin-left: 2px;
            font-size: 14px;
        }
        .compra-responsive {
            min-width: 40vw !important;
            margin-left: 5px !important;
            font-size: 14px !important;
        }
    }

    /* ── Bloqueo Visual: Campos Locked ── */
    .field-locked {
        position: relative;
    }

    .field-locked :deep(input),
    .field-locked :deep(select) {
        opacity: 0.7;
        background-color: #f8f9fa !important;
        cursor: not-allowed;
    }

    .lock-badge {
        display: inline-block;
        font-size: 11px;
        color: #6c757d;
        margin-top: 4px;
        font-weight: 500;
        letter-spacing: 0.5px;
    }
</style>
